'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import type { ListLimitVariant } from '@/new_components/lists/ListLimitDialog';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { ListGateError, useLists } from '@/hooks/use-lists';
import { useLocalePath } from '@/hooks/use-locale';

export function useCreateList(onNavigate?: () => void) {
  const { t } = useTranslation();
  const router = useRouter();
  const localePath = useLocalePath();
  const { create, isCreating } = useLists();
  const [gate, setGate] = useState<{
    variant: ListLimitVariant;
    limit?: number;
  } | null>(null);

  async function createList() {
    if (isCreating) return;
    try {
      const result = await create(t('lists.newListName'));
      if (result instanceof ListGateError) {
        setGate({
          variant: result.gate === 'pro' ? 'pro_required' : 'lists_limit',
          limit: result.limit,
        });
        return;
      }
      onNavigate?.();
      router.push(localePath(`/my-lists/${result.id}`));
    } catch {
      toast.error(t('overview.createFailed'));
    }
  }

  return { createList, isCreating, gate, closeGate: () => setGate(null) };
}
